function required(value) {
  return !!value || "Required";
}

export { required };
